import React from 'react';
import { siteData } from '../mock';

const Blog = () => (
  <section id="blog" className="relative overflow-hidden bg-black py-20 lg:py-32">
    <div className="grain-overlay opacity-25"></div>
    <div className="relative z-10 mx-auto max-w-7xl px-4 lg:px-8">
      <div className="mb-12 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:items-end">
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.28em] text-pink-accent">Notes</p>
          <h2 className="section-heading text-left">DIRECTIONAL WRITING</h2>
        </div>
        <p className="max-w-2xl text-sm leading-7 text-white/65 md:text-base">Enough copy to feel the voice. Not a full publishing system — just enough to understand the lane.</p>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {siteData.blog.map((post) => (
          <article key={post.id} className="blog-card rounded-[1.8rem] border border-white/10 bg-white/[0.03] p-6 backdrop-blur-sm">
            <span className="mb-6 inline-flex rounded-full border border-pink-accent/30 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.24em] text-pink-accent">{post.category}</span>
            <h3 className="mb-4 text-2xl font-semibold leading-tight text-white">{post.title}</h3>
            <p className="text-sm leading-7 text-white/65">{post.excerpt}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Blog;
